var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import scrollToElement from "scroll-to-element";
import Swiper from "swiper";
import { setCSSCustomProperty } from "../utils/css.utils";
import wait from '../utils/wait.utils';
// @ts-ignore
//GDPR_MANAGER.init();
var isPage = function (slug) { return document.body.classList.contains(slug); };
export var UIController = {
    init: function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.initMeasurementCheckers();
                _this.initContentTabs();
                _this.initAnchorLinksScroller();
                _this.checkStoredHash();
                _this.highlightCurrentPageLinks();
                _this.initGdprManager();
                _this.initFAQTriggers();
                if (isPage('home')) {
                    //this.initServicesSwiper();
                    //this.initRelatedPostsSwiper();
                }
                if (isPage('single')) {
                    _this.initRelatedPostsSwiper();
                }
                _this.wrapPaginationNumbers();
                // this.initRelatedPodcastsSwiper();
                _this.initSingleServiceHeaderSwiper();
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    initFAQTriggers: function () {
        var els = document.querySelectorAll('.faq-article__question');
        var toggleFaqItem = function (e) {
            e.preventDefault();
            var parentNode = e.currentTarget.parentNode;
            if (parentNode instanceof Element) {
                if (parentNode.classList.contains('open')) {
                    parentNode.classList.remove('open');
                }
                else {
                    parentNode.classList.add('open');
                }
            }
        };
        // Makes and array from querySelectorAll
        // For Each element in the array add the Event Listener of type click
        Array.from(els).forEach(function (el) {
            el.addEventListener('click', toggleFaqItem, { capture: true });
        });
        Array.from(els).forEach(function (el) {
            el.classList.remove('open');
        });
    },
    recordWindowDimensions: function () {
        var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
        setCSSCustomProperty('--vw', innerWidth + 'px');
        setCSSCustomProperty('--vh', innerHeight + 'px');
    },
    recordWpAdminBarHeight: function () {
        var el = document.getElementById('wpadminbar');
        var height = el ? el.clientHeight : 0;
        setCSSCustomProperty('--wp-admin-bar-height', height + 'px');
        return height;
    },
    recordNavBarHeight: function () {
        var el = document.querySelector('.section-site-nav');
        // const el = document.querySelector('.section-site-nav .nav');
        var height = el ? el.clientHeight : 0;
        setCSSCustomProperty('--nav-height', height + 'px');
        // console.log(height);
        return height;
    },
    recorSiteNavHeight: function () {
        var el = document.querySelector('.section-site-nav');
        var height = el ? el.clientHeight : 0;
        setCSSCustomProperty('--site-nav-height', height + 'px');
        return height;
    },
    initMeasurementCheckers: function () {
        var _this = this;
        var handleWindowLoad = function () {
            _this.recordWindowDimensions();
            _this.recordWpAdminBarHeight();
            _this.recordNavBarHeight();
            _this.recorSiteNavHeight();
        };
        var handleWindowResize = function () {
            _this.recordWindowDimensions();
            _this.recordWpAdminBarHeight();
            _this.recordNavBarHeight();
            _this.recorSiteNavHeight();
        };
        window.addEventListener('load', handleWindowLoad);
        window.addEventListener('resize', handleWindowResize);
    },
    initAnchorLinksScroller: function () {
        var _this = this;
        var els = document.querySelectorAll('.section-nav a[href*="#"], .view-main a[href*="#"]');
        var handler = function (e) {
            try {
                var target = e.target;
                var href = target === null || target === void 0 ? void 0 : target.getAttribute('href');
                if (!href)
                    return;
                var match = href === null || href === void 0 ? void 0 : href.match(/([^#]*)#(.*)/);
                if (!match)
                    return;
                var pathname = match[1];
                // console.log(match, pathname, window.location.pathname, pathname !== window.location.pathname);
                if (!!pathname && pathname !== window.location.pathname)
                    return;
                // do not do anything if the thing links to a different page
                var id = match[2];
                if (!id)
                    return;
                // only prevent default if an id is found
                e.preventDefault();
                _this.scrollToId(id);
            }
            catch (e) {
                console.error(e);
                return;
            }
        };
        Array.from(els).forEach(function (el) {
            el.addEventListener('click', handler);
        });
    },
    checkStoredHash: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.ID_HASH) return [3 /*break*/, 3];
                        return [4 /*yield*/, wait(500)];
                    case 1:
                        _a.sent();
                        this.scrollToId(window.ID_HASH);
                        return [4 /*yield*/, wait(618)];
                    case 2:
                        _a.sent();
                        window.location.hash = window.ID_HASH;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    scrollToId: function (id) {
        if (!id)
            this.scrollToTop();
        else {
            var offset = -1 * (this.recordWpAdminBarHeight() +
                this.recordNavBarHeight()
            // this.recordContentTabsHeight()
            );
            scrollToElement('#' + id, { offset: offset, ease: 'inOutCube', duration: 618 });
        }
    },
    scrollToTop: function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    },
    getSiteTitle: function () {
        return document.body.getAttribute('data-site-title');
    },
    getPageTitle: function () {
        var titleEl = (document.querySelector('.page-header__title') || document.querySelector('h1') || document.querySelector('title'));
        var title = titleEl && titleEl.innerText;
        return title || '';
    },
    initContentTabs: function () {
        var el = document.querySelector('.section-content-tabs');
        if (!el)
            return;
        var makeTab = function (title, url, active) { return "<li><a class=\"content-tab" + (active && ' active') + "\" href=\"" + url + "\" title=\"" + title + "\">" + title + "</a></li>"; };
        var tabSourceEls = Array.from(document.querySelectorAll('[data-content-tab-id]'));
        tabSourceEls.forEach(function (el) { var _a; return el.setAttribute('id', (_a = el.getAttribute('data-content-tab-id')) !== null && _a !== void 0 ? _a : ''); });
        var tabs = tabSourceEls.map(function (el) {
            var _a;
            return makeTab((_a = el.getAttribute('data-content-tab-title')) !== null && _a !== void 0 ? _a : '', '#' + el.getAttribute('data-content-tab-id'));
        });
        var pageTitle = this.getPageTitle();
        var hasHashOnLoad = !!window.location.hash;
        tabs.unshift(makeTab(pageTitle, '#', !hasHashOnLoad));
        var ul = el.querySelector('ul');
        if (ul)
            ul.innerHTML = tabs.join('');
        var anchors = Array.from(el.querySelectorAll('a'));
        var setActive = function (e) {
            var _a;
            anchors.forEach(function (a) { return a.classList.remove('active'); });
            var target = e.target;
            (_a = target) === null || _a === void 0 ? void 0 : _a.classList.add('active');
        };
        anchors.forEach(function (a) { return a.addEventListener('click', setActive); });
    },
    detectRatio: function (el) {
        if (!el)
            return;
        var w = el.clientWidth;
        var h = el.clientHeight;
        var ratio = w / h;
        var orientation = ratio >= 1 ? 'landscape' : 'portrait';
        el.setAttribute('data-element-width', w + 'px');
        el.setAttribute('data-element-height', h + 'px');
        el.setAttribute('data-element-ratio', ratio + '');
        el.setAttribute('data-element-orientation', orientation);
        setCSSCustomProperty('--element-width', w + 'px', el);
        setCSSCustomProperty('--element-height', h + 'px', el);
        setCSSCustomProperty('--element-ratio', ratio + '', el);
        setCSSCustomProperty('--element-orientation', orientation, el);
    },
    initRatioWatcher: function () {
        var _this = this;
        var els = document.querySelectorAll('[data-watch-ratio]');
        Array.from(els).forEach(function (el) {
            var handler = function () { return _this.detectRatio(el); };
            window.addEventListener('load', handler);
            window.addEventListener('resize', handler);
        });
    },
    initVideoCoverer: function () {
        var handler = function () {
            var videoSlides = document.querySelectorAll('.section-hero-banner');
            Array.from(videoSlides).forEach(function (slide) {
                var video = slide.querySelector('video');
                if (!video)
                    return;
                var checkVideoRatio = function () {
                    var videoWidth = video.videoWidth;
                    var videoHeight = video.videoHeight;
                    var videoRatio = videoWidth / videoHeight;
                    var containerWidth = slide.clientWidth;
                    var containerHeight = slide.clientHeight;
                    var containerRatio = containerWidth / containerHeight;
                    if (videoRatio >= containerRatio) {
                        // video is wider or square; 100% height and auto width.
                        video.setAttribute('data-fill-mode', 'fill-height');
                    }
                    else {
                        video.setAttribute('data-fill-mode', 'fill-width');
                    }
                };
                checkVideoRatio();
            });
        };
        window.addEventListener('load', handler);
        window.addEventListener('resize', handler);
    },
    highlightCurrentPageLinks: function () {
        var _a = window.location, origin = _a.origin, pathname = _a.pathname;
        var originRegExp = new RegExp('^' + origin);
        var anchors = document.querySelectorAll('a');
        var pathnameRegExp = new RegExp('^' + pathname);
        Array.from(anchors).forEach(function (a) {
            if (a.href) {
                var i = a.href.replace(originRegExp, '');
                var matches = a.classList.contains('fuzzy-match') ? i.match(pathnameRegExp) : i === pathname;
                // console.log(i, pathname, matches);
                if (matches)
                    a.classList.add('active');
            }
        });
    },
    // initServicesSwiper() {
    //   // Could be abstracted
    //   const swiperSlides = document.querySelectorAll('.services__swiper-container .swiper-slide');
    //   if (swiperSlides.length === 1) return;
    //   new Swiper('.services__swiper-container', {
    //     // loop: true,
    //     slidesPerView: 'auto',
    //     spaceBetween: 10,
    //     // autoplay: {
    //     //   delay: 6000,
    //     // },
    //     // speed: 3000,
    //     // navigation: {
    //     //   nextEl: '.swiper-button-next',
    //     //   prevEl: '.swiper-button-prev',
    //     // },
    //   });
    //   // Original for reference
    //   // const servicesSwiper = new Swiper('.services__swiper-container', {
    //   //   // slidesPerView: 2.5,
    //   //   slidesPerView: 'auto',
    //   //   // centeredSlides: true,
    //   //   spaceBetween: 10,
    //   // });
    // },
    initRelatedPostsSwiper: function () {
        // Could be abstracted
        var swiperSlides = document.querySelectorAll('.related-posts__swiper-container .swiper-slide');
        if (swiperSlides.length === 1)
            return;
        new Swiper('.related-posts__swiper-container', {
            // loop: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            // autoplay: {
            //   delay: 6000,
            // },
            // speed: 3000,
            // navigation: {
            //   nextEl: '.swiper-button-next',
            //   prevEl: '.swiper-button-prev',
            // },
        });
        // Original for reference
        // const relatedPostsSwiper = new Swiper('.related-posts__swiper-container ', {
        //   // slidesPerView: 2.5,
        //   slidesPerView: 'auto',
        //   // centeredSlides: true,
        //   spaceBetween: 10,
        // });
    },
    initRelatedPodcastsSwiper: function () {
        // Could be abstracted
        var swiperSlides = document.querySelectorAll('.post-item__swiper-container .swiper-slide');
        if (swiperSlides.length === 1)
            return;
        new Swiper('.post-item__swiper-container', {
            // loop: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            // autoplay: {
            //   delay: 6000,
            // },
            // speed: 3000,
            // navigation: {
            //   nextEl: '.swiper-button-next',
            //   prevEl: '.swiper-button-prev',
            // },
        });
        // Original for reference
        // const relatedPostsSwiper = new Swiper('.related-posts__swiper-container ', {
        //   // slidesPerView: 2.5,
        //   slidesPerView: 'auto',
        //   // centeredSlides: true,
        //   spaceBetween: 10,
        // });
    },
    initSingleServiceHeaderSwiper: function () {
        var singleServiceHeaderSwiper = new Swiper('.service-header__features__swiper', {
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                480: {
                    spaceBetween: 48,
                },
                // when window width is >= 640px
                // 640: {
                //   slidesPerView: 4,
                //   spaceBetween: 40
                // }
            },
            pagination: {
                el: '.swiper-pagination',
            },
            // Responsive breakpoints
        });
    },
    wrapPaginationNumbers: function () {
        try {
            // const pagination = document.querySelector('.pagination-links');
            var pagination = document.querySelector('.nav-links');
            if (!pagination)
                return;
            var numbers = pagination.querySelectorAll('.page-numbers:not(.prev):not(.next)');
            var numbersList = document.createElement('div');
            numbersList.classList.add('page-numbers-list');
            numbersList.append.apply(numbersList, Array.from(numbers));
            pagination.insertBefore(numbersList, pagination.lastChild);
        }
        catch (e) {
            console.warn('Failed to wrap pagination numbers, ignoring this error.');
        }
    },
    initGdprManager: function () {
        if (window.Cypress)
            return;
        // If you are testing and have clicked 'I consent', you can either open the site in an incognito tab, or run GDPR_CONSENT.reset() in your console to clear the local storage key. Refresh afterwards and you will see the banner again.
        // @ts-ignore
        GDPR_MANAGER.init({
            // delay: 1000, /** milliseconds to delay the banner from appearing. This only delays the banner and does not delay the onConsentValid function. */
            banner: {
                title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8V9C15 9.55228 14.5523 10 14 10H10C9.44772 10 9 9.55228 9 9V8ZM6 10C6.55228 10 7 9.55228 7 9V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V9C17 9.55228 17.4477 10 18 10V10C18.5523 10 19 10.4477 19 11V17C19 18.6569 17.6569 20 16 20H8C6.34315 20 5 18.6569 5 17V11C5 10.4477 5.44772 10 6 10V10ZM12 17C11.4477 17 11 16.5523 11 16V14C11 13.4477 11.4477 13 12 13V13C12.5523 13 13 13.4477 13 14V16C13 16.5523 12.5523 17 12 17V17Z" fill="white"/></svg>We Value Your Privacy',
                bodyHtml: "<p>turn2me uses cookies and similar technologies to personalise content, and to analyse traffic and app usage. Some are necessary for our website and application to work properly and can't be switched off, and some are optional but helps us support the experience for you and help improve services for all clients.</p>",
                showRemindMeLaterButton: false,
                showManageButton: true,
                style: {
                    backgroundColorFallback: '#4A4181',
                    backgroundColor: '#4A4181',
                    backgroundImage: 'linear-gradient(336.96deg, #4A4181 -17.01%, #29234F 140.47%)',
                    backdropBlur: false,
                    foregroundColor: '#ffffff',
                    linkColor: '#009FE3',
                    headingColor: 'inherit',
                    buttonBackgroundColor: 'rgba(255,255,255,.15)',
                    buttonForegroundColor: '#ffffff',
                    buttonBorderRadius: '5px',
                },
            },
            privacySettingsPanelConfig: {
                title: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8V9C15 9.55228 14.5523 10 14 10H10C9.44772 10 9 9.55228 9 9V8ZM6 10C6.55228 10 7 9.55228 7 9V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V9C17 9.55228 17.4477 10 18 10V10C18.5523 10 19 10.4477 19 11V17C19 18.6569 17.6569 20 16 20H8C6.34315 20 5 18.6569 5 17V11C5 10.4477 5.44772 10 6 10V10ZM12 17C11.4477 17 11 16.5523 11 16V14C11 13.4477 11.4477 13 12 13V13C12.5523 13 13 13.4477 13 14V16C13 16.5523 12.5523 17 12 17V17Z" fill="white"/></svg><span>Cookie & Privacy Settings</span>',
                style: {
                    panelBackgroundColor: '#4A4181',
                    panelForegroundColor: '#ffffff',
                    panelBackgroundImage: 'linear-gradient(356.95deg, #4A4181 -2.75%, #241D4B 99.82%);',
                },
                ESSENTIAL: {
                    description: [
                        '<p>Some cookies and similar technologies are used to run the website and application properly and cannot be turned off. This includes:</p>',
                        '<p>- Our own cookies / storage entries for account and security related functionalities, application state and data caching. Data collected and used to ensure security, prevent fraud, and debug may include automatically-sent device characteristics for identification, precise geolocation data, and data obtained by actively scanning device characteristics for identification without separate disclosure and/or opt-in.</p>',
                        '<p>- Notification system support: <a href="https://pusher.com/" title="Pusher.js Official Site" target="_blank" rel="noopener noreferrer">Pusher.js</a></p>',
                        '<p>- Payment providers: <a href="https://stripe.com/" title="Stripe" target="_blank" rel="noopener noreferrer">Stripe</a></p>',
                        '<p>- Application error reporting: <a href="https://sentry.io/" title="Sentry.io" target="_blank" rel="noopener noreferrer">Sentry.io</a></p>',
                        '<p>- Application usage behaviour: <a href="https://www.hotjar.com/" title="hotjar" target="_blank" rel="noopener noreferrer">hotjar</a></p>',
                        '<p>- This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</p>',
                    ].join('')
                },
                FACEBOOK_PIXEL: {
                    defaultOn: false,
                    description: "Collects marketing and advertisement information. This helps us to get more users in need to find our services. You can know more about how Facebook Pixel manages cookies and user/device information on their website.",
                },
                GOOGLE: {
                    defaultOn: false,
                    description: "Collects site traffic and usage information. This provides insight to where our visitors are coming from, and how everyone uses our services. This helps us to get more users in need to find our services, and understand our users better, which enables us to analyse and improve our service offerings for everyone. You can know more about how Google Analytics manages cookies and user/device information on their website.",
                },
                contentAfterSaveButton: [
                    '<p><em>* You can change above settings for this browser at any time by visiting the Privacy Settings page from your account page or global settings available in different areas of the website and application.</em></p>',
                    '<h3>More Options</h3>',
                    '<a href="/page/privacy" title="GDPR & Privacy Policy">→ Read our GDPR & Privacy Policy</a>'
                ].join(''),
            },
            reloadPageOnFirstConsent: false,
            analyticalIDs: {
                GTAG: 'GTM-WHQDCVB',
                GOOGLE_ANALYTICS: 'UA-9292097-1',
                FACEBOOK_PIXEL: '116123425926645',
                // GTAG: 'REPLACE',
                // GOOGLE_ANALYTICS: 'REPLACE',
                // FACEBOOK_PIXEL: 'REPLACE',
            },
        });
    }
};
